var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "VisibilityWorkFlow" } },
    [
      _c("VisibilityChanger", {
        attrs: { alertMessage: false },
        model: {
          value: _vm.form.visibility,
          callback: function ($$v) {
            _vm.$set(_vm.form, "visibility", $$v)
          },
          expression: "form.visibility",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }